import { BaseModel } from "../../../shared/base/base.models";
import { Country } from "../countries/countries.models";
export class BusinessPartner extends BaseModel {
    name?: string;
    type?: BusinessPartnerType;
    partnerGroup?: BusinessPartnerGroup;
    erpCode?: string;
    address?: string; 
    zipCode?: string;
    place?: string;
    country?: Country;
    idNumber?: string;
    vatPayer?: boolean;
    vatNumber?: string;
    contactPerson?: string;
    telephone?: string;
    fax?: string;
    email?: string;
    website?: string;
    geoX?: number;
    geoY?: number;
    status?: BusinessPartnerStatus;
}

export enum BusinessPartnerType {
    B2B_CUSTOMER
}

export enum BusinessPartnerGroup {
    BUSINESS_PARTNER_TYPE_I, BUSINESS_PARTNER_TYPE_II, BUSINESS_PARTNER_TYPE_III, BUSINESS_PARTNER_TYPE_IV, BUSINESS_PARTNER_TYPE_V
}

export enum BusinessPartnerStatus {
    ACTIVE, INACTIVE, SUSPENDED
}

export class DeliveryLocation {
    id?:string;
    businessPartner?: string;
    name?: string;
    type?: DeliveryLocationType;
    erpCode?: string;
    address?: string;
    zipCode?: string;
    place?: string;
    country?: string | Country;
    idNumber?: string;
    contactPerson?: string;
    phoneNumber?: string;
    faxNumber?: string;
    email?: string;
    geoX?: number;
    geoY?: number;
    status?: DeliveryLocationStatus;
    version?: number;
}

export enum DeliveryLocationType  {
    WHOLESALE_WAREHOUSE, RETAIL_LOCATION
}

export enum DeliveryLocationStatus  {
    ACTIVE, INACTIVE, SUSPENDED
}